import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    tracks_loading: false,
    date_range: [
      format(subDays(new Date(), 7), 'yyyy-MM-dd'),
      format(addDays(new Date(), 1), 'yyyy-MM-dd')
    ],
    videos: [],
    video_chart: [],
    tracks: [],
    page: 1,
    page_size: 10,
    order_column: 'published',
    order_type: 'desc',
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '15%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    }
  },

  mutations: {
    setVideoData(state, payload) {
      state.videos = payload
    },
    setVideoChart(state, payload) {
      state.video_chart = payload
    },
    setVideoTracks(state, payload) {
      state.tracks = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload[0], payload[1]]
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setTracksLoading(state, payload) {
      state.tracks_loading = payload
    }
  },

  actions: {
    readVideos({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('video_report_filter')
      filters = JSON.parse(ls)

      axios.api
        .get('report/data/video', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          // let data = r.data.data.data
          //   .reverse()
          //   .filter((d, i, s) => i === s.findIndex(t => t.video === d.video))
          commit('setVideoData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTopVideos({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('report/data/video')
        .then(r => {
          let data = r.data.data.data
            .reverse()
            .filter((d, i, s) => i === s.findIndex(t => t.video === d.video))
          commit('setVideoData', data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readVideoChart({ commit }, data) {
      axios.api
        .get(`report/data/video/${data.id}`, {
          params: {
            start: data.start,
            end: data.end,
            charts: true
          }
        })
        .then(r => {
          commit('setVideoChart', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          // commit('setLoading', false)
        })
    },

    readVideoTracks({ commit }, id) {
      commit('setTracksLoading', true)
      axios.api
        .get(`report/data/video/${id}`)
        .then(r => {
          commit('setVideoTracks', r.data.data[0].tracks)
          commit('setTracksLoading', false)
        })
        .catch(() => {
          commit('setTracksLoading', false)
        })
    }
  },

  getters: {
    video_chart_views: state => {
      let result = [['Date', 'Views']]
      state.video_chart.map(s => {
        if (s[1] !== 'Views') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[1])])
        }
      })
      return result
    },
    video_chart_views_daily: state => {
      let result = [['Date', 'Daily']]
      state.video_chart.map(s => {
        if (s[2] !== 'Daily') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), s[2]])
        }
      })
      return result
    },
    video_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.video_chart.map(s => {
        if (s[3] !== 'Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[3])])
        }
      })
      return result
    },
    video_chart_subscribers_daily: state => {
      let result = [['Date', 'Daily']]
      state.video_chart.map(s => {
        if (s[4] !== 'Daily Subscribers') {
          const date = new Date(s[0])
          result.push([date.toDateString().slice(3, 15), parseInt(s[4])])
        }
      })
      return result
    },
    top_5_videos: state => {
      let result = []
      state.videos.sort(function(a, b) {
        return parseFloat(b.subscribers) - parseFloat(a.subscribers)
      })
      result = state.videos.slice(0, 5)
      return result
    }
  }
}
